import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import NumberFormat from 'react-number-format';
import Tooltip from '../tooltip';
import BaseInput from './base';

const validate = val =>
  string()
    .required('Enter your Social Security Number')
    .min(9, 'Enter your Social Security Number')
    .validate(val.replace(/[^\d]/g, '').toString())
    .then(() => null)
    .catch(err => err.errors?.join(', '));

const Input = inputProps => (
  <BaseInput
    className="fs-exclude"
    label="My Social Security # *"
    type="number"
    name="ssn"
    maxLength={15}
    transparent
    autoComplete="off"
    useLocalState={false}
    endAdornment={
      <Tooltip
        text="We take your privacy and data protection seriously. All of your documents
          are covered by comprehensive security features including limited access control,
          audit trails, and encryption both in transit and at rest. Few things are as
          important to us as securing your personal information so we ensure your data stays protected."
      />
    }
    {...inputProps}
  />
);

const SocialSecurityNumber = ({ onTouched, onChange, ...rest }) => (
  <NumberFormat
    format="###-##-####"
    mask="_"
    onValueChange={values =>
      onChange({ ...values, name: 'ssn', type: 'number' }, validate)
    }
    {...rest}
    customInput={Input}
  />
);

SocialSecurityNumber.propTypes = {
  onChange: PropTypes.func.isRequired,
  onTouched: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string
};

SocialSecurityNumber.defaultProps = {
  onTouched: null,
  value: '',
  error: ''
};

export default SocialSecurityNumber;
